<template>
  <div :class="$attrs.class">
    <label
      v-if="label"
      class="form-label"
      :for="id">{{ label }}:</label>
    <textarea
      :id="id"
      ref="input"
      v-bind="{ ...$attrs, class: null }"
      class="form-textarea"
      :class="{ error: error }"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)" />
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </div>
</template>

<script lang="js">
export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default () {
                return `textarea-input-${self.crypto.randomUUID()}`
            },
        },
        error: String,
        label: String,
        modelValue: String,
    },
    emits: ['update:modelValue'],
    methods: {
        focus () {
            this.$refs.input.focus()
        },
        select () {
            this.$refs.input.select()
        },
    },
}
</script>
